import { COLLAGE_OPTIONS, TEMPLATE_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmToggleModel } from "common/models/utility-models/meta-model";

export class RegisterStep4MetaModel extends FormMetaModel {
    constructor() {
        super('', "", "", 3,null, true, 'step4','',' row align-items-start justify-content-start');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const instituteName = new SmMetaInputModel(
            'instituteName',
            'instituteName',
            'input',
            true,
            'col-12 col-md-4',
            1,
            1,
            'Engineering College Name',
            'text',
            "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            false,
            [],
            false,
            '',
            null,
            false,
            false,
            false,
            "Enter college Full Name",
            true,
            true
        );
     
        const instituteType = new SmMetaSelectModel(
            'instituteType',
            'instituteType',
            'select',
            true,
            'col-12 col-md-4 ',
            1,
            2,
            'Institute Type',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            COLLAGE_OPTIONS,
            'name',
            'id',
           
        );
        const instituteContact = new SmMetaInputModel(
            'instituteContact',
            'instituteContact',
            'input',
            false,
            'col-12 col-md-4',
            1,
            3,
            'Institute Phone',
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            10,
            // false,
            // false,
            // false,
            // false,
            // false,
            // false,
            // false,
            // '',
            // { evalKey: '', evalParam: [] },
            // false,
            // [],
            // false,
            // '',
            // null,
            // false,
            // false,
            // false,
            // "Institute Phone"
        );
        const instituteAddress = new SmMetaInputModel(
            'instituteAddress',
            'instituteAddress',
            'input',
            true,
            'col-12 col-md-4',
            1,
            4,
            'Institute Address',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            // false,
            // [],
            // false,
            // '',
            // null,
            // false,
            // false,
            // false,
            // "Institute Address"
        );
        
        
        const branchId = new SmMetaSelectModel(
            'branchId',
            'branchId',
            'select',
            true,
            'col-12 col-md-4 ',
            1,
            7,
            'Branch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'department_name',
            'id',

        );

        const firstYearFees = new SmMetaInputModel(
            'firstYearFees',
            'firstYearFees',
            'input',
            true,
            'col-12 col-md-4',
            1,
            6,
            'First year fees',
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            '',
            { evalKey: '', evalParam: [] },
            // false,
            // [],
            // false,
            // '',
            // null,
            // false,
            // false,
            // false,
            // "First year fees"
        );
        // const collageStateId = new SmMetaInputModel(
        //     'collageStateId',
        //     'collageStateId',
        //     'input',
        //     false,
        //     'col-12 col-md-4',
        //     1,
        //     7,
        //     'Collage State',
        //     'text',
        //     '',
        //     false,
        //     true,
        //     true,
        //     false,
        //     100,
        //     1
        // );

        const collageStateId = new SmMetaSelectModel(
            'collageStateId',
            'collageStateId',
            'select',
            true,
            'col-12 col-md-4 ',
            1,
            7,
            'College State',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'stateName',
            'id',

        );

        const anyScholarship = new SmToggleModel(
            'anyScholarship',
            'anyScholarship',
            'toggle',
            false,
            'col-12 p-0 ',
            1,
            8,
            'Do you have any other scholarships :',
            '',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            
        );

        

        const anyScholarshipName = new SmMetaInputModel(
            'anyScholarshipName',
            'anyScholarshipName',
            'input',
            false,
            'col-12 col-md-4',
            1,
            9,
            'Scholarship Name *',
            'text',
            "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
            false,
            true,
            true,
            false,
            50,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            "",
            { evalKey: 'anyScholarship', evalParam: [true] },
            // false,
            // [],
            // false,
            // '',
            // null,
            // false,
            // false,
            // false,
            // "Scholarship Name"

        );
        
        const offeringInstitute = new SmMetaInputModel(
            'offeringInstitute',
            'offeringInstitute',
            'input',
            false,
            'col-12 col-md-4',
            1,
            10,
            'Offering Institute *',
            'text',
            "^(?=.*[a-zA-Z])[a-zA-Z '-]+$",
            false,
            true,
            true,
            false,
            50,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            "",
            { evalKey: 'anyScholarship', evalParam: [true] },
            // false,
            // [],
            // false,
            // '',
            // null,
            // false,
            // false,
            // false,
            // "Offering Institute"
        );
        const scholarshipAmount = new SmMetaInputModel(
            'scholarshipAmount',
            'scholarshipAmount',
            'input',
            false,
            'col-12 col-md-4',
            1,
            11,
            'Scholarship Amount *',
            'number',
            '',
            false,
            true,
            true,
            false,
            100,
            1,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            "",
            { evalKey: 'anyScholarship', evalParam: [true] },
            // false,
            // [],
            // false,
            // '',
            // null,
            // false,
            // false,
            // false,
            // "Scholarship Amount"
        );

        return {
            formInfo,
            instituteName,
            instituteType,
            instituteContact,
            instituteAddress,
            branchId,
            firstYearFees,
            collageStateId,
            anyScholarship,
            anyScholarshipName,
            offeringInstitute,
            scholarshipAmount
        }
    }
}